import { useNavigate } from 'react-router-dom';
import { HomeIntro } from '../components/home/HomeIntro';
import { HomeBanners } from '../components/home/HomeBanners';
import { TrustStrip } from '../components/home/TrustStrip';
import { CategoryShowcase } from '../components/home/CategoryShowcase';
import { NewArrivals } from '../components/home/NewArrivals';
import { BestSellers } from '../components/home/BestSellers';
import { CollectionsCarousel } from '../components/home/CollectionsCarousel';
import { InstagramShowcase } from '../components/home/InstagramShowcase';
import { SocialProof } from '../components/home/SocialProof';

export function HomePage() {
  const navigate = useNavigate();

  const handleCollectionSelect = (collectionId: number) => {
    navigate(`/catalogo?col=${collectionId}`);
  };

  return (
    <>
      <h1 className="sr-only">Baby Chic: roupas e acessórios infantis de 1 a 14 anos, com envio para todo o Brasil</h1>
      <HomeBanners onSelectCollection={handleCollectionSelect} />
      <HomeIntro />
      <NewArrivals />
      <BestSellers />
      <CategoryShowcase />
      <CollectionsCarousel onSelectCollection={handleCollectionSelect} />
      <TrustStrip />
      <SocialProof />
      <InstagramShowcase />
    </>
  );
}
